/* ------------------------------------------------------------------
   File: Apply.jsx
   Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
   Last Modified: 2026-05-10
------------------------------------------------------------------ */

import React from 'react'

function Apply() {
  return (
    <div>
      Apply Page
    </div>
  )
}

export default Apply
